

import React, { useState, useEffect } from 'react'

import FixtureTemplate from './FixtureTemplate';
import Loader from '../../../../Loader/Loader';
import { getFixturesByDate } from '../../../../../api/api_football';
import { addCacheByKey, getCacheByKey } from '../../../../../cache/cache';
import { compareDates, isToday } from '../../../../../helpers/dateFormatter';

function FixturesByDate({ date, type, setAllFixtures, isLoading, setIsLoading, requestCount }) {

    const [fixtures, setFixtures] = useState()

    const [show, setShow] = useState(false);

    useEffect(() => {

        async function fetchLiveData() {
            setIsLoading(true)


            // GET FIXTURES IF NOT TODAY, 
            // IF FIXTURES ARE IN PAST, MAKE SURE RESULTS ARE ADDED, IF NOT CHECK STATUS FT / NS
            /* const localFixtures = getCacheByKey(`allFixtures${date}`);
            if (!isToday(date) && localFixtures?.fixtures?.length > 0) {
                if (compareDates(date, localFixtures.date_fixtures)) {
                    console.log("SAME DATES")
                    console.log(localFixtures, "LOCALFIXTURES")
                    const fixturesLS = {
                        fixtures: localFixtures?.fixtures,
                        date_updated: new Date().toISOString(),
                        date_fixtures: date,
                        date_added: localFixtures?.date_added
                    }

                    addCacheByKey(`allFixtures${date}`, fixturesLS)
                    setFixtures(localFixtures?.fixtures)
                    console.log("GETTING CACHED FIXTURES", isToday(date), "FIXTURES IS FROM FUTURE OR PAST", date);
                    return
                } else {
                    console.log("NOT SAME");
                }

            } */

            try {
                const data = await getFixturesByDate(date)
                setFixtures(data)
                setAllFixtures(data)

                const fixturesLS = {
                    fixtures: data,
                    date_added: new Date().toISOString(),
                    date_fixtures: date
                }

                addCacheByKey(`allFixtures${date}`, fixturesLS)

            } catch (error) {
                console.log(error)
            }
            setIsLoading(false)
        }
        fetchLiveData()

    }, [date, requestCount])

    function toggle() {
        if (show) {
            setShow(false);
        } else {
            setShow(true)
        }
    }

    return (
        <div>

            <div className="card card-header bg-lightgrey" onClick={toggle} style={{ cursor: "pointer" }}>
                <div>
                    <small>
                        Dagens program <span className="float-right"><i className={`fas fa-chevron-${show ? "down" : "up"}`}></i></span>
                    </small>
                </div>
            </div>
            {show && (
                <React.Fragment>
                    {isLoading ? <Loader /> : fixtures?.map((fixture, index) => {
                        return (
                            <div key={index}>
                                <FixtureTemplate type={type} fixture={fixture} />
                            </div>
                        )
                    })}
                </React.Fragment>
            )}


        </div>
    )
}
export default FixturesByDate